export default __webpack_public_path__ + "static/2-4b43defe57b8ef3db476ebf83e090882.webp";